import { useIsDesktop } from '@cian/valuation-utils-component';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { submitValuationForm } from '../../actions/submitValuationForm';
import { ValuationReady } from '../../components/OpenDataPaymentForm';
import { selectCheckEstimationExists } from '../../selectors/checkEstimationExists/selectCheckEstimationExists';

export const ValuationReadyContainer: React.VFC = () => {
  const dispatch = useDispatch();
  const isDesktop = useIsDesktop();
  const { estimationId } = useSelector(selectCheckEstimationExists);

  /**
   * При клике на плашку "Кажется, вы уже оценивали эту квартиру"
   * редирект на страницу результатов оценки
   */
  const handleClickEstimationReady = React.useCallback(() => {
    dispatch(submitValuationForm());
  }, [dispatch]);

  if (!estimationId) {
    return null;
  }

  return <ValuationReady isDesktop={isDesktop} onClick={handleClickEstimationReady} />;
};
